import { render, staticRenderFns } from "./Syspost.vue?vue&type=template&id=5659916e&scoped=true&"
import script from "./Syspost.vue?vue&type=script&lang=js&"
export * from "./Syspost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659916e",
  null
  
)

export default component.exports